const counters: { [key: string]: number } = {};

export const uniqueId = (prefix: string) => {
  counters[prefix] = (counters[prefix] || 0) + 1;
  return `${prefix}${counters[prefix]}`;
};
